module.exports = __webpack_public_path__ + "img/tipPicture.e2fcddac.png";